<template>
    <ul>
        <li v-for="(project, projectId) in orgSettings.customProjects" v-bind:key="projectId">
                <strong>{{ project.name }}</strong>&nbsp;<a v-if="enableFields && projectLines(projectId).length == 0" class="delete is-small" @click="deleteProject(projectId)"/>
            <InputCustomProjectLine :project="projectId" :enable-fields="enableFields"/>
        </li>
    </ul>
</template>

<script>
import firebase from '@/firebase'
import _ from 'lodash'

import InputCustomProjectLine from '@/components/inputs/InputCustomProjectLine.vue'

export default {
    name: 'InputCustomProject',
    props: {
        orgSettings: Object,
        enableFields: Boolean,
    },
    components: {
        InputCustomProjectLine
    },
    data() {
      return {
          projectName: '',
          projectLineName: '',
      }
    },
      firebase: function() { 
        const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
        return {
            settings: {
                source: firebase.database().ref('/organisations/' + tenantid + '/settings'),
                asObject: true,
            },
        }
    },
    methods: {
        deleteProject(projectId) {
            this.$firebaseRefs.settings.child('/customProjects/' + projectId).remove()
        },
        projectLines(projectId) {
            return _.filter(this.orgSettings.customProjectLines, {'project': projectId})
        },
    }
}
</script>

<style>

</style>
